import type { ReactNode } from "react";
import {
  GovernanceIcon,
  HistoryIcon,
  OfflineIcon,
  ReviewIcon,
  SettingsIcon,
  TodayIcon,
} from "./icons";

export type AppScreen = "today" | "review" | "governance" | "history" | "settings";

const NAV_ITEMS = [
  { id: "today" as const, label: "今天", Icon: TodayIcon },
  { id: "review" as const, label: "复盘", Icon: ReviewIcon },
  { id: "governance" as const, label: "治理", Icon: GovernanceIcon },
  { id: "history" as const, label: "历史", Icon: HistoryIcon },
  { id: "settings" as const, label: "设置", Icon: SettingsIcon },
];

export function AppFrame({
  screen,
  onNavigate,
  online,
  updateAvailable,
  onApplyUpdate,
  children,
}: {
  screen: AppScreen;
  onNavigate: (screen: AppScreen) => void;
  online: boolean;
  updateAvailable: boolean;
  onApplyUpdate: () => void;
  children: ReactNode;
}) {
  return (
    <div className={screen === "review" ? "app-frame app-frame--review" : "app-frame"}>
      {!online && (
        <div className="connectivity-banner" role="status">
          <OfflineIcon />
          当前离线。复盘仍会保存在此设备。
        </div>
      )}
      {updateAvailable && (
        <div className="update-banner" role="status">
          <span>新版本已准备好，不会自动打断当前填写。</span>
          <button type="button" className="text-button" onClick={onApplyUpdate}>
            保存后更新
          </button>
        </div>
      )}
      <div className="app-content">{children}</div>
      {screen !== "review" && (
        <nav className="bottom-nav" aria-label="主要导航">
          {NAV_ITEMS.map(({ id, label, Icon }) => (
            <button
              key={id}
              type="button"
              className={screen === id ? "bottom-nav__item is-active" : "bottom-nav__item"}
              aria-current={screen === id ? "page" : undefined}
              onClick={() => onNavigate(id)}
            >
              <Icon />
              <span>{label}</span>
            </button>
          ))}
        </nav>
      )}
    </div>
  );
}
